import React from "react";
import { isDefined, count, getSetting, CreateArray } from "../../../config/helpers";
import dynamic from "next/dynamic";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import useWindowSize from "../../../_hooks/useWindowSize";
import { useSelector } from "react-redux";
import PageTitle from "@components/Components/Reusables/PageTitle";
import P from "@components/Components/Reusables/Typography/P";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/GridLegacy";
import Image from "next/image";
import { useTemplatePageContent } from "@components/Components/Providers/TemplatePageContentContext";

const DefaultSkeleton = dynamic(() => import("../../Reusables/DefaultSkeleton"));
const BoxContainer = dynamic(() => import("../../Reusables/BoxContainerV2"));
const HomeProductCarousel = dynamic(() => import("../HomeProductCarousel"));
const HomeSlider = dynamic(() => import("../Slider/HomeSlider"));
const HomeClients = dynamic(() => import("../Clients/HomeClients"), {
    loading: () => (
        <>
            <div className="d-flex justify-space-evenly">
                <Stack spacing={5} direction="row">
                    <CreateArray length={6}>
                        <DefaultSkeleton width={175} height={150} />
                    </CreateArray>
                </Stack>
            </div>
        </>
    ),
    ssr: false
});

const HomeArticles = dynamic(() => import("../Articles/HomeArticles"));
const HomeContentMobile = dynamic(() => import("../HomeContentMobile"));
const HomeContentDesktop = dynamic(() => import("../HomeContentDesktop"));
const HomeDescription = dynamic(() => import("../HomeDescription"));
const HomeCategories = dynamic(() => import("../HomeCategories"));

const Home2 = ({ homeData }) => {
    const { template_settings /*, template_page_content,*/ } = useSelector((state) => state.globalReducer);
    const { tabs, long_term, template_page_settings, } = homeData;
    // const page_content = template_page_content['home'];

    const { template_page_content } = useTemplatePageContent();
    const page_content = template_page_content;

    const { isMobile } = useWindowSize();
    const layout = getSetting(
        template_settings,
        template_page_settings,
        "layout",
        "wide"
    );

    const { home_grid_columns, home_article_count } = template_page_settings;

    // const layout_width =
    // 		layout == "custom" ?
    // 		getSetting(
    // 			template_settings,
    // 			template_page_settings,
    // 			"custom_layout_width",
    // 			"0px"
    // 		):"0px";

    return (
        <div id="home" key="home" className="p-0 mb-5 pt-1 hide-horizontal-overflow">
            <BoxContainer mobileClasses={'p-0 pl-2 pr-2'}>
                <PageTitle
                    as="h1"
                    className="fw-semi-bold dark-grey text-center"
                >
                    Browse Furniture
                </PageTitle>

                <Divider className="mb-4 mt-0" />

                {/* <Box>
                        <Grid spacing={{xs: 2, md: 3}} container>

                            <Grid item xs={12} md={5}>
                                <Box
                                    className="position-relative"
                                    sx={{
                                        height: '280px',
                                    }} 
                                >
                                    <Image 
                                        style={{
                                            objectFit: 'cover'
                                        }}
                                        src={`/images/${process.env.brand.acronym}/about-exhibit-hire.jpg`}
                                        layout="fill"
                                        alt="About-us-EH"
                                    />

                                </Box>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Box
                                    className="dark-grey f-small"
                                >
                                    <P>
                                        We stock a large and diverse range of furniture hire items, displays, bars, exhibition equipment, etc, which we hire to the exhibition and events industry customers. We have built our reputation on providing the highest levels of furniture rental services, bar rental and exhibition rental to venues throughout London, UK and Europe. We are continuously buying and updating our furniture and display products, as we understand the importance of supplying premium quality furniture rental that will do both you and your clients proud. Maximise your budget with our superior furniture, available on low-cost, short lease periods.
                                    </P><br/>
                                    <P>
                                        Within our furniture rental range, we stock many modern and contemporary styles of hire furniture, from indoor/outdoor white sofas to luxury leather chairs. Our large and extensive range of led bar hire, will turn any event into a fantastic occasion and highly impress your clients and guests. In addition to our furniture hire service, we also manufacture and supply bespoke bars, exhibition stands & displays. Having recently invested in the latest CNC wood cutting machinery, we are able to manufacture innovative and professional displays, incorporating large format printing, at cost effective prices.
                                    </P>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider className="mb-4 mt-4" /> */}
                <Box className="mb-5">
                    {/* <ImageTile imagePass={homeData.categories} home_grid_columns={home_grid_columns}/> */}
                    <HomeCategories
                        categories={homeData.categories}
                        home_grid_columns={3}
                        includeBanner={false}
                        vanillaText={true}
                    />
                    {page_content.section_1 && <HomeDescription isMobile={isMobile} home_page_title='' />}
                </Box>

            </BoxContainer>

            <Box className={(layout == 'box' && !isMobile) || (!isMobile) ? 'boxed-padding mb-5 mt-6' : ''}>
                {
                    isDefined(tabs) && count(Object.keys(tabs)) > 0 && (
                        <HomeProductCarousel
                            tabs={tabs}
                            long_term={long_term}
                            data={homeData}
                        />
                    )
                }
            </Box>

            <BoxContainer mobileClasses={'p-0 mt-4'}>
                {isMobile ? <HomeContentMobile /> : <HomeContentDesktop />}
            </BoxContainer>

            <BoxContainer mobileClasses={'p-0 mt-4'}>




            </BoxContainer>
        </div>
    );

}

export default React.memo(Home2);